import { v4 as uuidv4 } from 'uuid';

export function ProductSpecificationValues(props = {}, childrenComponents = []) {
	return {
		componentName: 'ProductSpecificationValues',
		componentId: uuidv4(),
		props,
		childrenComponents,
	};
}
